import React, { useState, useMemo } from "react";
import { useHolidays, holidayOf } from "../../hooks/useHolidays";
import AppointmentForm from "./appointments/AppointmentForm";
import AgendaCalendar, { buildEvents } from "./appointments/AgendaCalendar";
import EventDetail from "./appointments/EventDetail";
import QuickCreate from "./appointments/QuickCreate";
import WorkloadPanel from "./appointments/WorkloadPanel";
import ReplaceModal from "../admin/interventions/ReplaceModal";
import { AgendaToolbar, AgendaListView } from "./appointments/AgendaViews";
import { useAgendaData, isMemberEvent, isServiceEvent } from "./appointments/useAgendaData";
import { hasService } from "../../lib/services";

const weekYears = (weekStart) => (weekStart ? [weekStart.getFullYear(), new Date(weekStart.getTime() + 6 * 86400000).getFullYear()] : [new Date().getFullYear()]);

const AppointmentsPanel = ({ onNavigate, isMaster = true }) => {
  const [view, setView] = useState("calendar");
  const [who, setWho] = useState("");
  const [service, setService] = useState("");
  const [quick, setQuick] = useState(null);
  const [selected, setSelected] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [weekStart, setWeekStart] = useState(null);
  const [replacing, setReplacing] = useState(null);
  const holidays = useHolidays(weekYears(weekStart));
  const { appts, interventions, prospects, team, absences, doli, loading, refreshKey, load, add, remove, move } = useAgendaData(holidays);

  const member = team.find((u) => u.login === who);
  const events = useMemo(() => buildEvents(appts, interventions, doli.events).filter((e) => isMemberEvent(e, member) && isServiceEvent(e, service)), [appts, interventions, doli.events, member, service]);
  const serviceLogins = useMemo(() => (service ? new Set(team.filter((u) => hasService(u, service)).map((u) => u.login)) : null), [team, service]);
  const memberAbsences = useMemo(() => (member ? absences.filter((a) => a.login === member.login) : absences), [absences, member]);

  const onAdd = async (form) => { const ok = await add(form); if (ok) setShowForm(false); return ok; };
  const onMove = async (kind, id, date) => { if (await move(kind, id, date)) setSelected(null); };
  const onDeleteRdv = (id) => { remove(id); setSelected(null); };

  return (
    <div>
      <AgendaToolbar view={view} setView={setView} who={who} setWho={setWho} service={service} setService={setService} team={team} onNavigate={onNavigate} onReload={load} onNew={() => setShowForm(!showForm)} />
      {showForm && <AppointmentForm prospects={prospects} onSubmit={onAdd} loading={loading} />}
      {doli.error && <p className="text-sm text-amber-600 mb-3">Dolibarr indisponible : {doli.error}</p>}
      {selected && <EventDetail e={selected} onClose={() => setSelected(null)} onDeleteRdv={onDeleteRdv} onGoInterventions={onNavigate ? () => onNavigate("interventions") : null} onReplace={setReplacing} />}
      {replacing && <ReplaceModal intervention={replacing} onClose={() => setReplacing(null)} onDone={() => { setSelected(null); load(); }} />}

      {view === "calendar" && weekStart && <WorkloadPanel weekStart={weekStart} refreshKey={refreshKey} isMaster={isMaster} serviceLogins={serviceLogins} />}
      {view === "calendar" && <AgendaCalendar events={events} onMove={onMove} onSelect={setSelected} onCreate={setQuick} holidays={holidays} onWeekChange={setWeekStart} absences={memberAbsences} />}
      {quick && <QuickCreate date={quick} holiday={holidayOf(holidays, quick)} prospects={prospects} team={team} onClose={() => setQuick(null)} onCreated={load} />}

      <AgendaListView visible={view === "list"} appts={appts} prospects={prospects} doli={doli} onRemove={remove} />
    </div>
  );
};

export default AppointmentsPanel;
